/* tslint:disable */
/* eslint-disable */
/**
 * Brokers API
 * API for managing brokers
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddressDto } from './AddressDto';
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    AddressDtoToJSONTyped,
} from './AddressDto';

/**
 * Mise à jour d'un courtier (cabinet + compte de référence). Tous les champs sont réécrits ; une adresse absente (null) laisse l'adresse actuelle en place. Les plateformes envoyées remplacent celles du compte de référence.
 * @export
 * @interface UpdateBrokerCommand
 */
export interface UpdateBrokerCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateBrokerCommand
     */
    companyName: string;
    /**
     * Adresse choisie dans la recherche Google (place_id requis) ; null = inchangée.
     * @type {AddressDto}
     * @memberof UpdateBrokerCommand
     */
    address?: AddressDto | null;
    /**
     * Téléphone de l'entreprise (standard), facultatif.
     * @type {string}
     * @memberof UpdateBrokerCommand
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrokerCommand
     */
    registrationNumber: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateBrokerCommand
     */
    capital?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrokerCommand
     */
    rcsCity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrokerCommand
     */
    rcsNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrokerCommand
     */
    oriasNumber: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrokerCommand
     */
    rcp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrokerCommand
     */
    complaintEmail: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrokerCommand
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBrokerCommand
     */
    lastName: string;
    /**
     * E-mail du compte de référence (le changer change la connexion du courtier).
     * @type {string}
     * @memberof UpdateBrokerCommand
     */
    email: string;
    /**
     * Identifiant du compte de référence (le changer change la connexion du courtier).
     * @type {string}
     * @memberof UpdateBrokerCommand
     */
    username: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateBrokerCommand
     */
    plateformeIds: Array<string>;
}

/**
 * Check if a given object implements the UpdateBrokerCommand interface.
 */
export function instanceOfUpdateBrokerCommand(value: object): value is UpdateBrokerCommand {
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('registrationNumber' in value) || value['registrationNumber'] === undefined) return false;
    if (!('oriasNumber' in value) || value['oriasNumber'] === undefined) return false;
    if (!('complaintEmail' in value) || value['complaintEmail'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('plateformeIds' in value) || value['plateformeIds'] === undefined) return false;
    return true;
}

export function UpdateBrokerCommandFromJSON(json: any): UpdateBrokerCommand {
    return UpdateBrokerCommandFromJSONTyped(json, false);
}

export function UpdateBrokerCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBrokerCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'companyName': json['companyName'],
        'address': json['address'] == null ? undefined : AddressDtoFromJSON(json['address']),
        'phone': json['phone'] == null ? undefined : json['phone'],
        'registrationNumber': json['registrationNumber'],
        'capital': json['capital'] == null ? undefined : json['capital'],
        'rcsCity': json['rcsCity'] == null ? undefined : json['rcsCity'],
        'rcsNumber': json['rcsNumber'] == null ? undefined : json['rcsNumber'],
        'oriasNumber': json['oriasNumber'],
        'rcp': json['rcp'] == null ? undefined : json['rcp'],
        'complaintEmail': json['complaintEmail'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'username': json['username'],
        'plateformeIds': json['plateformeIds'],
    };
}

export function UpdateBrokerCommandToJSON(json: any): UpdateBrokerCommand {
    return UpdateBrokerCommandToJSONTyped(json, false);
}

export function UpdateBrokerCommandToJSONTyped(value?: UpdateBrokerCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyName': value['companyName'],
        'address': AddressDtoToJSON(value['address']),
        'phone': value['phone'],
        'registrationNumber': value['registrationNumber'],
        'capital': value['capital'],
        'rcsCity': value['rcsCity'],
        'rcsNumber': value['rcsNumber'],
        'oriasNumber': value['oriasNumber'],
        'rcp': value['rcp'],
        'complaintEmail': value['complaintEmail'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'username': value['username'],
        'plateformeIds': value['plateformeIds'],
    };
}

